import { Grid, Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

const styles = {
    CircularProgress: {
        mr: 1,
        color: "#FFFFFF"
    }
}

export default function SignInButton(props: any) {
    const { enableSignIn, setUserNameAndPasswordEncoded, signInProgress } = props;
    const { t } = useTranslation();

    if (signInProgress) {
        return (
            <Grid item md={7} xs={11}>
                <Grid item md={12} xs={12} pt={2}>
                    <Button className="Scan-Button Scan-Button-Active" disabled fullWidth onClick={setUserNameAndPasswordEncoded}><CircularProgress sx={styles.CircularProgress} size={25} />{t('loginPage.signInButton.signingIn')}</Button>
                </Grid>
            </Grid>
        )
    } else {
        return (
            <Grid item md={7} xs={11}>
                <Grid item md={12} xs={12} pt={2}>
                    <Button className="Scan-Button Scan-Button-Active" disabled={!enableSignIn} fullWidth onClick={setUserNameAndPasswordEncoded}>{t('loginPage.signInButton.signIn')}</Button>
                </Grid>
            </Grid>
        )
    }

}